// extracted by mini-css-extract-plugin
module.exports = {"base":"src-ModalContainer-base-453204c3"};